var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('van-tabbar',{attrs:{"border":false,"placeholder":true}},[_c('div',{staticClass:"logo-bar"},[_c('img',{staticClass:"logo-size jelly-feel",attrs:{"src":require("@/assets/images/sucai/logo.png"),"alt":"tabbar-icon"},on:{"click":function($event){return _vm.nextTo()}}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }